export enum OwnerEnum {
  JORNADA = 'Jornada',
  PLATAFORMA = 'Plataforma',
  JUSCALC = 'JusCalc',
  GDC = 'GDC',
  PAGAMENTOS = 'Pagamentos',
  INOVACAO = 'Inovação',
  AGC = 'AGC',
  JUSFINDER = 'Jusfinder',
}

export enum FeatureEnum {
  DASHBOARD = 'dashboard',
  HELP_CENTER = 'helpcenter',
  PROFILE = 'user profile',
  SUBSCRIPTION_CANCEL = 'subscription_cancel',
  SUBSCRIPTION_MANAGEMENT = 'subscription_management',
  ONBOARDING = 'onboarding',
  SIGNIN = 'signin',
  CHECKOUT = 'checkout',
  JUSFY_PAY = 'jusfypay',
  JUS_PROCESSOS = 'jusprocessos',
  CALCULATOR_AI = 'juscalc',
  CALCULATOR = 'juscalc',
  JUSFINDER = 'jusfinder',
  DRIVE = 'jusdrive',
  CUSTOMER_MANAGEMENT = 'jusclient',
  JUS_SIGN = 'jussign',
  JUS_PDF = 'jusfile',
  LICENCE_MANAGEMENT = 'licence_management',
  /** Destino por evento da FT-1166 para `onboarding_find_opportunities_clicked`. */
  JUSMATCH = 'jusmatch',
  // Squad Inovação — valores do de-para de features (IHE-47).
  JUSGPT = 'jusgpt',
  /** IA Personalizada: engine B2B do JusGPT, contada à parte. */
  JUSGPT_B2B = 'jusgpt_b2b',
  JUSZAP = 'juszap',
  JUSPAGE = 'juspage',
  JUSMAIL = 'jusmail',
  JUSACCOUNTING = 'jusaccounting',
  /** Busca direta na base de jurisprudência (micro-front em iframe). */
  JURISPRUDENCE = 'jurisprudence',
  /** Academy (aluno): eventos academy_* vindos do iframe do jusrecruta-front. */
  JUSACADEMY = 'jusacademy',
  GAMIFICATION = 'gamification',
  /**
   * `JusrecrutaEmbed` já usava este literal (`feature: 'JusRecruta'`) sem que
   * o enum tivesse o membro correspondente, o que reprovava o gate de
   * Segment (ft-1166) em qualquer commit no repo, mesmo sem relação com o
   * arquivo alterado. Adicionado aqui para destravar o gate — não faz parte
   * da feature que motivou esta mudança (FT-2174).
   */
  JUS_RECRUTA = 'JusRecruta',
  /**
   * Eventos que não contam o usuário como ativo na plataforma (Afiliados, MGM,
   * notificação, banner de oferta de feature). Único membro para todos eles —
   * de-para da FT-1166.
   */
  NOT_FEATURE = 'not_feature',
}

/**
 * Subdivisão dentro de uma `feature`, para quando uma feature cobre mais de um
 * produto. Hoje só `JusProcessos` precisa: monitoramento de processos e gestão
 * de prazos passaram a dividir a mesma feature, e `module` é o que os separa.
 */
export enum ModuleEnum {
  JUS_PROCESSOS = 'JusProcessos',
  DEADLINES_MANAGEMENT = 'Gestão de Prazos',
}

export enum GroupIdEnum {
  JUSGPT_GROUP = 'jusgpt-group',
  JUSFINDER_GROUP = 'jusfinder-group',
  JUSPROCESSOS_GROUP = 'jusprocessos-group',
  JUSCALC_GROUP = 'juscalc-group',
  JUSSIGN_GROUP = 'jussign-group',
  JUSPAGE_GROUP = 'juspage-group',
  JUSSPACE_GROUP = 'jusspace-group',
  JUSMAIL_GROUP = 'jusmail-group',
  GENERAL_GROUP = 'general-group',
  CLIENTS_GROUP = 'clients-group',
  SUBUSERS_GROUP = 'subusers-group',
  DEADLINES_GROUP = 'deadlines-group',
  JUSFYPAY_GROUP = 'jusfypay-group',
  JUSZAP_GROUP = 'juszap-group',
  JUSMATCH_GROUP = 'jusmatch-group',
  JUSDECISION_GROUP = 'jusdecision-group',
  PETITIONS_GROUP = 'petitions-group',
  GAMIFICATION_GROUP = 'gamification-group',
  FEATURE_OFFER_GROUP = 'feature-offer-group',
  AGC_GROUP = 'agc-group',
  INSTAGRAM_GROUP = 'instagram-group',
  /**
   * JusScore RH — a carteira de pessoas com score contínuo.
   *
   * Grupo próprio e não `JUSFINDER_GROUP`: o JusScore avulso do Jusfinder é uma
   * consulta pontual de um CPF, e este é um acompanhamento de carteira. Medir os
   * dois no mesmo grupo misturaria uso pontual com uso recorrente.
   */
  JUSSCORE_GROUP = 'jusscore-group',
}

export interface BaseEventProperties {
  owner: string;
  /** Product feature grouping for analytics. Prefer over `category`. */
  feature?: string;
  /** Subdivisão dentro da `feature` (ex.: 'Gestão de Prazos'). Opcional. */
  module?: string;
  /** @deprecated Prefer `feature`. Optional during migration. */
  category?: string;
  event_meaning: string;
  duration?: number | string;
  relevant_user_activity: boolean;
  user_id?: string | number;
  /** Boolean going forward (FT-1138); `1` is the legacy numeric value already emitted by Clientes/Drive. */
  filtro_hubspot?: boolean | 1;
}

export type ContextualProperties = Record<string, unknown>;

export type TProperties = BaseEventProperties & ContextualProperties;

export interface TContext {
  groupId: string;
  library: {
    name: string;
    componente: string;
  };
  traits?: Record<string, unknown>;
  [key: string]: unknown;
}

export interface AnalyticsEvent {
  event: string;
  properties: TProperties;
  context: TContext;
}
